/** Full-width scroll region for Admin Configuration / module hub settings content. */
export const ADMIN_HUB_PAGE = "page-scroll w-full min-w-0 space-y-5";
